export const SERVICE_LOCATION_ACCESS_TOOLTIP =
  'You need to be given access to the service location to create external service tickets.';

export function canCreateExternalServiceTicketForLocation(params: {
  canAccessService: boolean;
  isAdmin?: boolean;
  isManager?: boolean;
  serviceLocationId?: string | null;
  allowedLocationIds?: readonly string[] | null;
}): boolean {
  if (!params.canAccessService || !params.serviceLocationId) return false;
  if (params.isAdmin || params.isManager) return true;
  return (params.allowedLocationIds ?? []).includes(params.serviceLocationId);
}
